export const ADD_TO_CART = 'add-to-cart';
export const ANNOTATION_LINK_IMG = 'annotation-link-image';
export const ANNOTATION_LINK_TITLE = 'annotation-link-title';
export const DISLIKE = 'dislike';
export const LIKE = 'like';
export const MODAL = 'modal';
export const PDP = 'pdp';
export const REMOVE_DISLIKE = 'remove-dislike';
export const REMOVE_FROM_CART = 'remove-from-cart';
export const REMOVE_LIKE = 'remove-like';
export const SEE_ALTERNATES = 'see-alternates';
export const SHOP_SIMILAR_ITEMS = 'shop-similar-items';
